import { useEffect, useState } from 'react';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import StripeService from '../../Services/http/StripeService';
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch, useSelector } from 'react-redux';
import { setIsExistsInStripe } from '../../Redux/UserSlice';
import { Box, Button, FormControl, FormLabel, InputLabel, MenuItem, Select } from '@mui/material';
import StripeUtils from './StripeUtils';
import { setIsActiveSpinner } from '../../Redux/GeneralSlice';
import UsBankAccountForm from './UsBankAccountForm';
import { useParams } from 'react-router-dom';

function UpdatePaymentMethodForm() {
  const appearance = {
    theme: 'flat'
  };

  const { userId } = useParams();

  const elements = useElements();
  const stripe = useStripe();
  const dispatch = useDispatch();
  const is_exists_in_stripe = useSelector((state: any) => state.user.is_exists_in_stripe);
  const [paymentMethod, setPaymentMethod] = useState('us_bank_account');
  const [existingPaymentMethods, setExistingPaymentMethods] = useState([]);
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null);
  const [username, setUsername] = useState(null);

  useEffect(() => {
    if (is_exists_in_stripe) {
      getPaymentMethods();
    }
  }, []);

  const getPaymentMethods = async () => {
    const data = await StripeUtils.getAllPaymentMethods(dispatch, userId);
    if (data.success) {
      setExistingPaymentMethods(data.payment_methods);
      setDefaultPaymentMethod(data.default_payment_method);
      setUsername(data.username);
    } else if (data.error === 'customer_id_stripe not exists') {
      console.log('customer not exists');
    } else {
      alert("error in get payment methods: " + data.error)
    }
  };

  const getClientSecretStripe = async (payment_method_type) => {
    const data = await StripeUtils.getClientSecret(payment_method_type, userId);
    if (data.success) {
      return data.client_secret;
    } else {
      alert("An error occurred geting client secret in stripe");
      dispatch(setIsActiveSpinner(false));
      return null;
    }
  };

  const createCustomerStripe = async () => {
    try {
      const data = await StripeUtils.createCustomer(userId);
      if (data.success) {
        dispatch(setIsExistsInStripe(true));
        return true;
      } else {
        alert("An error occurred creating a customer in stripe");
        return false;
      }
    } catch (error) {
      console.log('Error fetching create customer in stripe:', error);
      return false;
    }
  };

  const getClientSecret = async (payment_method_type) => {
    let client_secret_stripe;
    if (is_exists_in_stripe) {
      client_secret_stripe = await getClientSecretStripe(payment_method_type) as string;
    } else {
      const res = await createCustomerStripe();
      if (res) {
        client_secret_stripe = await getClientSecretStripe(payment_method_type) as string;
      }
    }
    return client_secret_stripe;
  };

  const saveNewCard = async (client_secret_stripe) => {
    const { error, setupIntent } = await stripe.confirmCardSetup(client_secret_stripe, {
      payment_method: { card: elements.getElement(CardElement) }
    });
    if (error) {
      console.error(error);
      alert("Error in adding payment method !!")
    } else {
      const res = await StripeUtils.updatePaymentMethodToDefault(
        dispatch, setupIntent.payment_method, userId
      );
      if (res) {
        elements.getElement(CardElement).clear(); // Clear the card element
        getPaymentMethods();
        alert("Successfully added payment method !!")
      }
      console.log('Setup intent succeeded:', setupIntent);
    }
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      dispatch(setIsActiveSpinner(true));
      let client_secret_stripe = await getClientSecret('card');
      if (!stripe || !elements) {
        return;
      }
      if (!client_secret_stripe) {
        return;
      }
      saveNewCard(client_secret_stripe);
      dispatch(setIsActiveSpinner(false));
    } catch {
      dispatch(setIsActiveSpinner(false));
    }
  };

  const formatDate = (month, year) => {
    const date = new Date(year, month - 1); // Subtract 1 from the month since it is zero-based
    const formattedDate = date.toLocaleString('default', { month: 'long', year: 'numeric' });
    return formattedDate;
  };

  const setPaymentMethodToDefault = async (paymentMethodId) => {
    const res = await StripeUtils.updatePaymentMethodToDefault(dispatch, paymentMethodId, userId);
    if (res) {
      getPaymentMethods();
      alert("Successfully updated payment method !!")
    }
  };

  const onChangePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 3 }}>
      <Box>
        {(username && userId) ? <h2>User: {username}</h2> : ""}

        <h2>Add new payment method</h2>
        {/* <Grid item xs={12} sm={6} md={12} mb={1}> */}
        <InputLabel id="demo-simple-select-label">
          Payment Method Type*
        </InputLabel>
        <FormControl fullWidth sx={{ width: "70%", mb: 3 }}>
          <Select
            size='small'
            name="role"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={paymentMethod}
            onChange={onChangePaymentMethod}
            // onBlur={handleBlur}
            variant="outlined"
          >
            <MenuItem value='us_bank_account'>US Bank Account</MenuItem>
            <MenuItem value='card'>Card</MenuItem>
          </Select>
        </FormControl>
        {/* </Grid> */}

        {paymentMethod === 'card' &&
          <form onSubmit={handleSubmit} style={{ width: '450px' }}>
            <FormLabel sx={{ marginBottom: "20px" }}>
              Card details
              <Box sx={{ marginTop: "15px", marginBottom: "15px" }}>
                <CardElement options={{
                  style: {
                    base: {
                      fontSize: '16px',
                      color: '#424770',
                      '::placeholder': {
                        color: '#aab7c4',
                      },
                    },
                    invalid: {
                      color: '#9e2146',
                    },
                  },
                  hidePostalCode: true, // Hide the postal code field
                }} />
              </Box>

            </FormLabel>
            <Button
              type="submit"
              variant="outlined"
              className="blue-btn"
              sx={{ marginTop: "15px" }}
              disabled={!stripe}
            >
              Save
            </Button>
          </form>}
        {paymentMethod === 'us_bank_account' &&
          <UsBankAccountForm getClientSecret={getClientSecret} userId={userId} getPaymentMethods={getPaymentMethods} />
        }
      </Box>
      <Box>
        <h2>Payment methods available</h2>
        {existingPaymentMethods.map(item =>
          <Box sx={{
            marginBottom: '15px', flexDirection: 'row', display: 'flex',
            boxShadow: "0px 7px 20px rgba(100, 100, 111, 0.15)", borderRadius: "12px", p: 3
          }} key={item.id}>
            {item.type === "card" && <Box sx={{ width: "250px" }}>
              <p>Type: <span className='bold'>Card</span></p>
              <p>Brand: {item.card.brand}</p>
              <p>Last 4 digits: {item.card.last4}</p>
              <p>Expiration date: {formatDate(item.card.exp_month, item.card.exp_year)}</p>
            </Box>}
            {item.type === "us_bank_account" && <Box sx={{ width: "250px" }}>
              <p>Type: <span className='bold'>US bank account</span></p>
              <p>Bank Name: {item.us_bank_account.bank_name}</p>
              <p>Routing Number: {item.us_bank_account.routing_number}</p>
              <p>Account Number: ****{item.us_bank_account.last4}</p>
            </Box>}
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 4, width: '80px' }}>
              {item.id === defaultPaymentMethod && <span className='red-color'>Default</span>}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: "20px" }}>
              {item.id !== defaultPaymentMethod &&
                <Button variant="text"
                  sx={{ width: 'max-content' }}
                  onClick={() => setPaymentMethodToDefault(item.id)}
                >Set as default</Button>}
            </Box>
          </Box>
        )}
      </Box>
    </Box >
  );
}

export default UpdatePaymentMethodForm;